module.exports = __webpack_public_path__ + "img/tool-second-section_1000.f81537f5.webp";